import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoading = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"aria-labelledby": "ShuttlerockLoadingTitle",
	xmlns: "http://www.w3.org/2000/svg",
	x: 0,
	y: 0,
	viewBox: "0 0 40 40",
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", {
			id: "ShuttlerockLoadingTitle",
			children: "Shuttlerock"
		}),
		/* @__PURE__ */ _jsx("style", { children: ".st2{fill:#e71f2f}" }),
		/* @__PURE__ */ _jsx("path", {
			className: "st2",
			d: "M25.2 36.1c-.8.8-.8 2.1.1 2.9.4.4.9.6 1.4.6.5 0 1.1-.2 1.5-.6l7.1-7.4c.8-.8.8-2.1-.1-2.9-.8-.8-2.1-.8-2.9.1l-7.1 7.3zM22.2 27.6c-.8.8-.8 2.1 0 2.9.4.4.9.6 1.4.6.5 0 1.1-.2 1.5-.6L39.4 16c.8-.8.8-2.1 0-2.9-.8-.8-2.1-.8-2.9 0L22.2 27.6zM12.1 7.8c.8-.8.8-2.1.1-2.9s-2.2-.9-3-.1L.6 13c-.8.8-.8 2.1-.1 2.9.4.4.9.6 1.5.6.5 0 1-.2 1.4-.6l8.7-8.1zM27.6 4c.8-.8.8-2.1 0-2.9-.8-.8-2.1-.8-2.9 0L10.3 15.2c-.8.8-.8 2.1 0 2.9.4.4.9.6 1.5.6.5 0 1-.2 1.4-.6L27.6 4zM39.3 4c.8-.8.8-2.1 0-2.9-.8-.8-2.1-.8-2.9 0L11.3 26.3c-.8.8-.8 2.1 0 2.9.4.4.9.6 1.5.6s1.1-.2 1.5-.6L39.3 4z"
		})
	]
});
export default SvgLoading;
